import { css, cx } from 'emotion';
import LeftBG from 'inside-out/images/profiles/get-involved-left-bg.svg';
import RightBG from 'inside-out/images/profiles/get-involved-right-bg.svg';

import {
	purple,
	headingLarge,
	tabletPortraitMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const getInvolvedWrapperStyle = css({
	maxWidth: '656px',
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
});

export const getInvolvedStyle = css({
	background: purple,
	padding: '94px 0',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: '30px 0',
	},
});

export const getInvolvedInnerStyle = css({
	backgroundImage: `url(${LeftBG}), url(${RightBG})`,
	backgroundPosition: 'bottom left, top right',
	backgroundRepeat: 'no-repeat',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		backgroundImage: 'none',
	},
});

export const ctaStyle = css({
	textAlign: 'center',
	marginTop: '36px',
	'& a': {
		color: '#fff',
	},
});

export const titleStyle = cx(
	headingLarge,
	css({
		color: '#fff',
		textAlign: 'center',
		marginBottom: '67px',
		marginTop: 0,
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			lineHeight: '47px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '20px',
			lineHeight: '23px',
			marginBottom: '20px',
		},
	})
);



// WEBPACK FOOTER //
// ./src/components/shared/getInvolved/styles.js